import { FC } from "react";

import { IRideDto } from "@ryde/shared";

import { FeedbackCountCell } from "../../grid";
import { IRenderColumnTemplate } from "./_core";

export const FeedbacksCountCellTemplate: FC<IRenderColumnTemplate> = ({
  rowOriginal,
}) => {
  return (
    <FeedbackCountCell
      {...(rowOriginal as Partial<IRideDto>)}
    ></FeedbackCountCell>
  );
};
